let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fI42n")).then(() => parcelRequire('XbJnA'));